import React from "react";

function SeriesIcons() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
    >
      <g
        id="Group_32210"
        data-name="Group 32210"
        transform="translate(-0.389 0.026)"
      >
        <rect
          id="Rectangle_14206"
          data-name="Rectangle 14206"
          width="36"
          height="36"
          transform="translate(0.389 -0.026)"
          fill="#596970"
          opacity="0"
        />
        <g
          id="Group_32209"
          data-name="Group 32209"
          transform="translate(6.039 4.026)"
        >
          <path
            id="Exclusion_1"
            data-name="Exclusion 1"
            d="M15.47,26H3.326A3.33,3.33,0,0,1,0,22.674V3.326A3.33,3.33,0,0,1,3.326,0h12.14a3.311,3.311,0,0,1,2.844,1.6,1,1,0,0,1,.469.848v.544a3.238,3.238,0,0,1,.017.338V22.674a3.26,3.26,0,0,1-.017.338v.544a1,1,0,0,1-.468.847A3.312,3.312,0,0,1,15.47,26ZM7.448,10.111a.225.225,0,0,0-.225.225V16.7a.23.23,0,0,0,.038.125.225.225,0,0,0,.312.062l4.774-3.181a.23.23,0,0,0,.062-.063.225.225,0,0,0-.062-.312L7.574,10.148A.221.221,0,0,0,7.448,10.111ZM22.667,21.762H20.852V4.238h1.815V21.761ZM26,19.151H24.185V6.846H26v12.3Z"
            transform="translate(0.35 -0.051)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}

export default SeriesIcons;
